module.exports = __webpack_public_path__ + "static/media/aggreement.ed7bc9d7.pdf";